<template>
    <header>
        <div>
          <a href="" @click="$parent.toggleDarkMode">
              <icon icon-name="moon"><icon-moon/></icon>
          </a>

          <LocalizedLink to="/"></LocalizedLink>
        </div>

        <a :href="linkedin" target="_blank">
            <icon icon-name="linkedin"><icon-linkedin/></icon>
        </a>
    </header>
</template>

<script>
    import Icon from "./IconBase";
    import IconLinkedin from "./icons/linkedin"
    import IconMoon from "./icons/moon"
    import LocalizedLink from "@/components/LocalizedLink"
    import {getSupportedLocales} from "@/util/i18n/supported-locales";

    export default {
        name: "Header",
        props: {
            linkedin: {
                type: String,
                default: () => { return ''; }
            },
        },
        components: {
            Icon, IconLinkedin, IconMoon, LocalizedLink
        },
        data: () => ({ locales: getSupportedLocales() }),
        methods: {
          linkCreator: function (locale) {
            return locale == 'he' ? '/en/' : '/'
          }
        }
    }
</script>

<style lang="sass" scoped>
    header
        width: 100%
        height: 180px
        padding: 0 92px
        z-index: 1

        position: fixed
        top: 0
        margin: 0 auto

        display: flex
        flex-wrap: nowrap
        justify-content: space-between
        align-items: center

        a
            color: $dark-grey !important
            line-height: 24px
            text-decoration: none
            padding: .2em
            @media (pointer: coarse)
                padding: .8em

        svg
            path
                fill: $dark-grey

    @media screen and (max-width: $mobile-break-point)
        header
            height: auto
            padding: 20px
</style>